import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import bgimg from "../Assets/Images/bg-2.jpg";
import Footerlogo from "../Assets/Images/logo.png";
import social1 from "../Assets/Images/social-icon-1.png";
import social2 from "../Assets/Images/social-icon-2.png";
import social3 from "../Assets/Images/social-icon-3.png";
// import AddLikedNFTidAction from
function Footer({ settheme, currenttheme }) {
  const handleChange = (event) => {
    if (currenttheme === "Darktheme") {
      settheme("LightTheme");
      localStorage.setItem("Theme", "LightTheme");
    } else {
      localStorage.setItem("Theme", "Darktheme");
      settheme("Darktheme");
    }
  };
  return (
    <>
      <div className="footer container-fluid">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${bgimg})` }}
        ></div>
        <Row>
          <Container>
            <Row>
              <Col xl="6" lg="6" md="6">
                <img className="footer-logo" src={Footerlogo} alt="Logo" />
                <h6>Powered by {""}
                <Link to="https://ammag.tech/">
                <h6>
                Ammag.com
                  </h6>  
                  </Link>
                  </h6>
              </Col>
              {/* <Col xl="6" lg="6" md="6" className="text-right">
                                <Button className="reg-btn">Add RedLight Network</Button>
                                <Button className="theme-btn" onClick={() => { handleChange() }}>
                                    <i className="fa fa-sun-o"></i>
                                    <i className="fa fa-moon-o"></i>
                                </Button>
                            </Col> */}
            </Row>
          </Container>
        </Row>
        <div className="footer-bottom">
          <Row>
            <Container>
              <Row>
                <Col xl="8" lg="8" md="8">
                  <ul className="inline-list">
                    <li>Ammag Scanner © 2023 Ammag.Tech</li>
                    <li>Built by the team Ammag.Tech</li>
                  </ul>
                </Col>
                <Col xl="4" lg="4" md="4">
                  <ul className="social-list">
                    <li>
                      <Link to="/" taget="_blank">
                        <img src={social1} alt="Social Icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" taget="_blank">
                        <img src={social2} alt="Social Icon" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/" taget="_blank">
                        <img src={social3} alt="Social Icon" />
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
    </>
  );
}
export default Footer;
